import jwt_decode from "jwt-decode";
import { userSignIn } from "../api";
import { toast } from "react-toastify";

const HandleLogin = (username, password) => {
  let data = { email: username, password };
  let Status = false;
  const promise = userSignIn(data);

  // Show a loading toast
  toast.promise(promise, {
    pending: "Logging in...",
  });

  // Callback for when the promise is resolved
  promise.then((res) => {
    localStorage.setItem("Token", res.data.token);

    const decodedToken = jwt_decode(res.data.token);
    localStorage.setItem("name", decodedToken.name);
    localStorage.setItem("Username", decodedToken.username);
    localStorage.setItem("Email", decodedToken.email);
    localStorage.setItem("UserType", decodedToken.userType);
    Status = true;
    toast.success("Login Sucess");
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  }).catch((err) => {
    console.error(err);
    if (err.response.data.error === !undefined || null) {
      toast.error(err.response.data.error || "Login Error");
    } else {
      toast.error("Unable to Login ");
    }
  });

  return { Status };
};

export default HandleLogin;
